const MAP = {
  bozza: ["Bozza", "bg-[#FEF3C7] text-[#92400E] border-[#FDE68A]"],
  in_firma: ["In firma", "bg-[#E0F2FE] text-[#075985] border-[#BAE6FD]"],
  firmato: ["Firmato", "bg-[#DCFCE7] text-[#166534] border-[#BBF7D0]"],
  annullato: ["Annullato", "bg-[#FEE2E2] text-[#991B1B] border-[#FECACA]"],
};

export const StatusBadge = ({ status, testId }) => {
  const [label, cls] = MAP[status] || [status, "bg-gray-100 text-gray-700 border-gray-200"];
  return (
    <span data-testid={testId || "status-badge"} className={`inline-flex items-center text-[10px] font-semibold uppercase tracking-widest px-2.5 py-1 rounded-full border ${cls}`}>
      {label}
    </span>
  );
};

export const STATUS_LABELS = { bozza: "Bozza", in_firma: "In firma", firmato: "Firmato", annullato: "Annullato" };
